import script from "./WeekStart.vue?vue&type=script&setup=true&lang=js"
export * from "./WeekStart.vue?vue&type=script&setup=true&lang=js"

import "./WeekStart.vue?vue&type=style&index=0&id=c4d67c3a&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/spa-headless/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4d67c3a"]])

export default __exports__